import { useTranslation } from 'react-i18next';
import { Icons } from '../Icons';

interface EditModeToggleProps {
  isEditMode: boolean;
  onToggle: () => void;
  onReset?: () => void;
}

export function EditModeToggle({ isEditMode, onToggle, onReset }: EditModeToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="edit-mode-toggle">
      <button
        onClick={onToggle}
        className={`edit-toggle-btn ${isEditMode ? 'active' : ''}`}
        title={isEditMode ? t('dashboard.exitEditMode', 'Terminer') : t('dashboard.editLayout', 'Personnaliser')}
      >
        {isEditMode ? (
          <>
            <Icons.Check size={16} />
            <span>{t('dashboard.done', 'Terminer')}</span>
          </>
        ) : (
          <>
            <Icons.Layout size={16} />
            <span>{t('dashboard.customize', 'Personnaliser')}</span>
          </>
        )}
      </button>

      {isEditMode && onReset && (
        <button
          onClick={onReset}
          className="reset-layout-btn"
          title={t('dashboard.resetLayout', 'Réinitialiser la disposition')}
        >
          <Icons.RotateCcw size={14} />
          <span>{t('dashboard.reset', 'Réinitialiser')}</span>
        </button>
      )}

      <style>{`
        .edit-mode-toggle {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .edit-toggle-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 14px;
          border: 1px solid var(--border);
          border-radius: 8px;
          background: var(--bg-secondary);
          color: var(--text-primary);
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .edit-toggle-btn:hover {
          background: var(--bg-tertiary);
          border-color: var(--primary);
        }

        .edit-toggle-btn.active {
          background: var(--primary);
          color: white;
          border-color: var(--primary);
        }

        .reset-layout-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 6px 10px;
          border: 1px solid var(--border);
          border-radius: 6px;
          background: transparent;
          color: var(--muted);
          font-size: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .reset-layout-btn:hover {
          color: var(--danger);
          border-color: var(--danger);
        }
      `}</style>
    </div>
  );
}
